<template>
  <div class="component-list-paid-true">
    <app-loading :isFull="true" v-if="isLoading"/>
    <vue-modaltor
      :visible="isModal"
      @hide="hideModal"
      :default-width="'50%'"
      :bg-overlay="'rgba(0, 0, 0, 0.7)'"
      :resize-width="{1200:'60%',992:'80%',768:'90%'}"
    >
      <div class="container-fluid">
        <div class="wrapper-form mb-3 p-4">
          <div class="row">
            <div class="col-6 mb-2">
              <div class="group-form">
                <input
                  type="text"
                  v-validate="'required'"
                  name="deficits"
                  :class="{active:fix.deficits != '' || fix.deficits == 0 }"
                  v-model="fix.deficits"
                >
                <span class="bar"></span>
                <label class="statr">کسورات</label>
                <span v-if="errors.has('deficits')" class="is-danger">فیلد نباید خالی باشد</span>
              </div>
            </div>
            <div class="col-6 mb-2">
              <div class="group-form">
                <input
                  type="text"
                  v-validate="'required'"
                  name="deficits_percent"
                  :class="{active:fix.deficits_percent != ''  || fix.deficits_percent == 0}"
                  v-model="fix.deficits_percent"
                >
                <span class="bar"></span>
                <label class="statr">درصد کسری</label>
                <span v-if="errors.has('deficits_percent')" class="is-danger">فیلد نباید خالی باشد</span>
              </div>
            </div>
            <div class="col-6 mb-2">
              <div class="group-form">
                <input
                  type="text"
                  v-validate="'required'"
                  name="msgs"
                  :class="{active:fix.msgs != '' }"
                  v-model="fix.msgs"
                >
                <span class="bar"></span>
                <label class="statr">پیغام</label>
                <span v-if="errors.has('msgs')" class="is-danger">فیلد نباید خالی باشد</span>
              </div>
            </div>
            <div class="col-6 mb-2">
              <div class="group-form">
                <input
                  type="text"
                  v-validate="'required'"
                  name="pay_amount"
                  :class="{active:fix.pay_amount != '' || fix.pay_amount == 0 }"
                  v-model="fix.pay_amount"
                >
                <span class="bar"></span>
                <label class="statr">
                  پرداختی خالص
                  <i>به ریال</i>
                </label>
                <span v-if="errors.has('pay_amount')" class="is-danger">فیلد نباید خالی باشد</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="text-center d-flex justify-content-center">
        <button
          @click="fixAdjest"
          class="mt-1 font-14 bttn-fill bttn-md bttn-success"
          v-ripple
        >تایید</button>
      </div>
    </vue-modaltor>
    <b-table stacked="lg" :fields="fieldsItems" :items="allAdjustment" class="font-14 text-center">
      <template v-slot:cell(date)="row" >{{row.item.date | date}}</template>
      <template v-slot:cell(action)="row" >
        <div class="text-center d-flex justify-content-center">
          <button
            @click="openModal(row)"
            class="mt-1 font-14 bttn-fill bttn-md bttn-success"
            v-ripple
          >تسویه</button>
        </div>
      </template>
      <template v-slot:cell(deficits)="row" >
        <p class="mb-0" v-if="row.item.deficits">{{row.item.deficits | currency}}</p>
        <p class="mb-0" v-else>0</p>
      </template>
      <template v-slot:cell(impure_earned)="row" >
        <p class="mb-0" v-if="row.item.impure_earned">{{row.item.impure_earned | currency}}</p>
        <p class="mb-0" v-else>0</p>
      </template>
      <template v-slot:cell(pay_amount)="row" >
        <p class="mb-0" v-if="row.item.pay_amount">{{row.item.pay_amount | currency}}</p>
        <p class="mb-0" v-else>0</p>
      </template>
      <template v-slot:cell(paid)="row" >
        <p class="mb-0">{{row.item.paid ? 'تسویه شده' : 'در حال بررسی' }}</p>
      </template>
      <template v-slot:cell(pay_amount)="row" >
        <p class="mb-0" v-if="row.item.pay_amount">{{row.item.pay_amount | currency}}</p>
        <p class="mb-0" v-else>0</p>
      </template>
      <template v-slot:cell(pay_mode)="row" >
        <p class="mb-0">{{row.item.pay_mode =='cash' ? 'نقدی' : 'الکترونیک'}}</p>
      </template>
      <template v-slot:cell(paid)="row" >
        <p class="mb-0">{{row.item.Paid | currency}}</p>
      </template>
    </b-table>
    <page-number :lengthList="lengthList" @callBack="getAllAdjustment"/>
  </div>
</template>

<script>
export default {
  name: 'component-list-paid-false',
  data() {
    return {
      fix: {
        deficits: 0,
        deficits_percent: 0,
        id: 0,
        msgs: '',
        pay_amount: 0
      },
      lengthList: 10,
      pay_mode: 'wallet',
      isLoading: false,
      isInstructor: false,
      fieldsItems: [
        { key: 'date', label: 'تاریخ' ,sortable: true},
        { key: 'fullname', label: 'نام کاربری' },
        { key: 'deficits', label: 'کسورات' ,sortable: true},
        { key: 'deficits_percent', label: 'درصد کسورات',sortable: true },
        { key: 'impure_earned', label: 'درآمد خالص',sortable: true },
        { key: 'msgs', label: 'پیغام' },
        { key: 'pay_amount', label: 'مبلغ پرداختی',sortable: true },
        { key: 'pay_mode', label: 'نحوه تسویه' },
        { key: 'action', label: 'تسویه' }
      ],
      allAdjustment: [],
      isModal: false,
      page: 1
    }
  },
  computed: {
    level() {
      return this.$store.state.auth.level
    }
  },
  mounted() {
    this.isInstructor = this.checkAccess(false)
    this.getAllAdjustment(1)
  },
  methods: {
    hideModal() {
      this.isModal = false
    },
    openModal(row) {
      this.fix.id = row.item.id
      this.isModal = true
    },
    async getAllAdjustment(p) {
      try {
        this.isLoading = true
        let { data } = await axios.post('/adjustment/get-all', {
          page_num: p,
          paid: false
        })
        this.isLoading = false
        if (data.state != 200) {
          return
        }
        this.lengthList = data.adjusts.length
        if (data.adjusts.length > 0) {
          this.allAdjustment = data.adjusts
        }
      } catch (error) {
        console.log(error)
      }
    },
    async  fixAdjest() {
      try {
        let result = await this.$validator.validate()
        if (!result) {
          this.$root.showWarnMsg({
            message: 'لطفا فرم را تکمیل کنید ... '
          })
          return
        }
        this.isLoading = true
        let { data } = await axios.post('/adjustment/fix', this.fix)
        this.isLoading = false
        if (data.state != 200) {
          return
        }
        this.fix = {
          deficits: 0,
          deficits_percent: 0,
          id: 0,
          msgs: '',
          pay_amount: 0
        }
        this.$validator.reset();
        this.hideModal()
        this.getAllAdjustment(1)
        this.$root.showInfoMsg({
          message: 'با موفقیت انجام شد'
        })
      } catch (error) {
        this.fix = {
          deficits: 0,
          deficits_percent: 0,
          id: 0,
          msgs: '',
          pay_amount: 0
        }
        this.$validator.reset();
        this.$root.showErrorMsg({
          message: error
        })
        console.log(error)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard-component/my-payment/list-paid-false.vue